AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.ValidationExampleController extends AccessController
    constructor: (@scope, @transitions, @service, @q, @http) ->
        super('validation_example', @http)

        # Turn on mfResizable
        @scope.validateOnLoad = true
        @scope.fullpage = true
        @scope.title = 'Official Validation Example'

        @scope.obj =
            wash: ''
            kaylee: ''
        @scope.jayne =
            selected_name: ''
            options: [
                'Jayne Cobb'
                'Hero of Canton'
                'The Man They Call Jayne'
                'Chain of Command Holder'
                'Adam Baldwin'
            ]
        @scope.simon = []

        # Not used directly by directive anymore. Look in the blade for use.
        @scope.validateOnLoad = true
        @scope.tooltipPlacement = 'left'

        @scope.save = @save

    save: () =>
        @service.save(
            @scope.obj.wash
            @scope.obj.kaylee
            @scope.jayne.selected_name
            @scope.simon
        )
